import Repository from './Repository';
// import { identify } from 'logrocket';

const resource = '/page';

export default {
    getPage(slug, type = 'page', site_template) {
        return Repository.get(`${resource}/${slug}?type=${type}&site_template=${site_template}`)
    },

    getStandalonePagesApi() {
        return Repository.get('standalone_pages')
    },

    getPages(params)
    {
      // params = {
      //   "site_template": id,
      //   "sort": {
      //     "modified": -1
      //   }
      // }

        const paramsToString = Object.entries(params).reduce((acc, cur) => {
            const seperator = acc === "" ? "?" : "&";          
            return acc + seperator + `${cur[0]}=${cur[1]}`;
        }, "");
        return new Promise((resolve, reject) => {
            if (params.hasOwnProperty("site_template")) {
              return Repository.get(`/pb-pages${paramsToString}`).then(result => {
                resolve(Object.values(result.data.pages));
              });
            }

            if (window.authorController) {
                let pages = window.authorController.getPages() // TODO CHANGE?
                resolve(pages)
            }

            reject()
        })
    },

    savePage(slug, type = 'page', site_template, payload) {
        return Repository.post(`${resource}/${slug}?type=${type}&site_template=${site_template}`, payload)
    },

    savePageSeo (slug, type = 'page', site_template,  pageSeo) {
        return Repository.post(`${resource}/${slug}/metadata?type=${type}&site_template=${site_template}`, pageSeo)
    },

    buildPage (payload) {
        return Repository.post(`create_page`, payload)
    },

    buildPageAPI(payload) {
        return Repository.post(`create_page_api`, payload)
    },

    deletePage(slug, site_template) {
        return Repository.delete(`${resource}/${slug}?site_template=${site_template}`)
    },

    resetPage(type, source) {
        var query = Object.keys(source)
            .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(source[k]))
            .join('&');

        return Repository.get(`/page_default/${type}?${query}`)
    },

    clonePage(pageId, data) {
        return Repository.post(`/page/${pageId}/clone`, data)
    }
}
